var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-price"},[_c('img',{staticClass:"price-ico",class:'price-ico-'+_vm.size,attrs:{"src":_vm.priceType == 2 &&  _vm.app == 'ios' ? _vm.config.entity_price_ico : _vm.config.price_ico,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }